var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"grey"}},[_c('img',{staticClass:"pa-1",class:_vm.classLogo,style:(_vm.styleLogo),attrs:{"src":require("@/assets/logo.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }